class SectionFeedback implements ng.IComponentController {
    ltTitle: string;
    list: string[];
}

angular.module('animatronApp.sectionFeedback', []).component('sectionFeedback', {
    bindings: {
        ltTitle: '<',
        list: '<'
    },
    controller: SectionFeedback,
    templateUrl: require('landing-template/components/sections/section-feedback.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionFeedback.ts